import {
  Button,
  Classes,
  Dialog,
  FormGroup,
  H5,
  HTMLSelect,
  HTMLTable,
  Icon,
  InputGroup,
  Popover,
  Switch,
  Tab,
  Tabs,
  Tooltip,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { api_adm } from "../../api";
import { ICalc } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { CalcStore } from "../../stores/calculo/CalcStore";
import { toast } from "react-toastify";
import * as moment from "moment";
import {
  MDBBtn,
  MDBCol,
  MDBRow,
} from "mdbreact";
import { CalcsClassificacaoPage } from "./CalcsClassificacao";
import { handleValidCalcs } from "../../utils";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField
} from "react-bootstrap-table";
import { AppIcon } from "../utils/AppIcon";
import InfoModal from "../info-modal/InfoModal";

interface CalcsPageProps { }

interface CalcsPageState {
  listCalcs: any[];
  listIdsClass: any[];
}

@observer
export class CalcsPage extends React.Component<CalcsPageProps, CalcsPageState> {
  obs = observable({
    duplicateName: "" as string,
    modalCreateClassificacao: false as boolean,
    codigo_receita: "" as string,
    nome_classificacao: "" as string,
    filter_vigencia: "vigentes" as string,
    dae_avulso: false as boolean,
    dei: false as boolean,
    codigo_ajuste: "" as string,
    open_ajuda: false as boolean,
    cod_or: "" as string,
    open_select_calcs: false as boolean,
    open_select_class: false as boolean,
    apuracao_saida: false as boolean,
    texto_ajuda: "" as string,
  })

  constructor(props) {
    super(props);

    this.state = {
      listCalcs: [],
      listIdsClass: [],
    }

  }

  async componentDidMount() {

    AppStore.setTitle("Formas de Cálculo");

    await CalcStore.handleCalcFiltered(CalcStore.obs.tipo, CalcStore.obs.filterText, this.obs.filter_vigencia);

  }

  handleCreate = () => {
    AppStore.setLocation("/calc/create");
  };


  handleChangeVigencia(e: string) {
    this.obs.filter_vigencia = e;
    CalcStore.handleCalcFiltered(CalcStore.obs.tipo, CalcStore.obs.filterText, this.obs.filter_vigencia)
  }

  async handleChangeTab(tableId) {
    CalcStore.obs.tipo = tableId

    if (tableId == "classificacao") { CalcStore.obs.filterText = "" }

    if (tableId != "classificacao") {
      await CalcStore.handleCalcFiltered(tableId, CalcStore.obs.filterText, this.obs.filter_vigencia)
    }

  }

  async handleDelete(calc: ICalc) {
    try {
      let params = { id: calc._id, tipo: CalcStore.obs.tipo }

      await api_adm.post(`/api/admin/calcs/delete`, params);

      toast.success(`Cálculo excluído: ${calc.nome}`, {});

      if (calc.contas_id) {
        CalcStore.obs.tipo = "contas"
        CalcStore.handleCalcFiltered(CalcStore.obs.tipo, CalcStore.obs.filterText, this.obs.filter_vigencia);
      } else if (calc.entrada) {
        CalcStore.obs.tipo = "entrada"
        CalcStore.handleCalcFiltered(CalcStore.obs.tipo, CalcStore.obs.filterText, this.obs.filter_vigencia);
      } else if (calc.saida) {
        CalcStore.obs.tipo = "saida"
        CalcStore.handleCalcFiltered(CalcStore.obs.tipo, CalcStore.obs.filterText, this.obs.filter_vigencia);
      } else {
        CalcStore.obs.tipo = "outros"
        CalcStore.handleCalcFiltered(CalcStore.obs.tipo, CalcStore.obs.filterText, this.obs.filter_vigencia);
      }
    } catch (ex) {
      toast.error(`Erro ao excluir Cálculo!`, {});
    }
  }

  handleEdit(calc: ICalc) {
    AppStore.setLocation(`/calc/edit/${calc._id}/${CalcStore.obs.tipo}`);
  }

  async handleFilter(filter: string) {
    CalcStore.obs.filterText = filter
    let filtro = filter.toLowerCase()
    await CalcStore.handleCalcFiltered(CalcStore.obs.tipo, filtro, this.obs.filter_vigencia);
  }

  async handleDuplicate(calc: ICalc) {
    try {
      let params = {
        nome: this.obs.duplicateName,
        tipo: CalcStore.obs.tipo,
        id: calc._id
      }
      await api_adm.post(`/api/admin/calcs/duplicate`, params);
      toast.success('Cálculo duplicado', {});
      CalcStore.handleCalcFiltered(CalcStore.obs.tipo, CalcStore.obs.filterText, this.obs.filter_vigencia);
    } catch (ex) {
      toast.error('Erro ao duplicar Cálculo!', {})
    }
  }

  handleRefresh() {
    window.location.reload();
  }

  handleSaveClassificacao = async () => {

    if (!this.obs.nome_classificacao) {
      toast.error('Preencha o nome da classificação`', {});
      return;
    }

    let params = {
      codigo_receita: this.obs.codigo_receita,
      nome: this.obs.nome_classificacao,
      codigo_ajuste: this.obs.codigo_ajuste,
      dae_avulso: this.obs.dae_avulso,
      dei: this.obs.dei,
      estado: "PA",
      ids_calc_credito_entrada: this.state.listCalcs,
      cod_or: this.obs.cod_or ? this.obs.cod_or : null,
      apuracao_saida: this.obs.apuracao_saida,
      ids_cassificacao_self: this.state.listIdsClass
    };

    let resp = await CalcStore.createClassificacao(params)

    if (resp) {

      await CalcStore.handldeBuscaClassificacao();

      this.obs.modalCreateClassificacao = false;

    }

  };

  async handleCreateClass() {

    this.setState({ listCalcs: [], listIdsClass: [] });

    this.obs.codigo_receita = ""
    this.obs.nome_classificacao = ""
    this.obs.codigo_ajuste = ""
    this.obs.dae_avulso = false
    this.obs.cod_or = ""
    this.obs.apuracao_saida = false
    this.obs.dei = false

    this.obs.modalCreateClassificacao = true;

    await CalcStore.handleCalcs();

  }

  createCustomSearchFieldSol = (props) => {
    return (
      <SearchField
        className="input-filter input-filter-sefa input-filter-calcs"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Nome)"
      />
    );
  };

  handleCheckCalcs = async (row, checked) => {

    if (checked) {

      this.setState(state => { state.listCalcs.push(row.id) });

    } else {

      let index = this.state.listCalcs.indexOf(row.id);

      this.state.listCalcs.splice(index, 1);

    }

  };

  handleCheckCalcsAll = async (check, row) => {

    if (check) {

      this.setState({ listCalcs: row?.map(value => value.id) });

    } else {

      this.setState({ listCalcs: [] });
    }

  };

  handleCheckClass = async (row, checked) => {

    if (checked) {

      this.setState(state => { state.listIdsClass.push(row.id) });

    } else {

      let index = this.state.listIdsClass.indexOf(row.id);

      this.state.listIdsClass.splice(index, 1);

    }

  };

  handleCheckClassAll = async (check, row) => {

    if (check) {

      this.setState({ listIdsClass: row?.map(value => value.id) });

    } else {

      this.setState({ listIdsClass: [] });
    }

  };

  render() {

    let itemns = handleValidCalcs(CalcStore.obs.calcs_index, CalcStore.obs.sub_tipo).map(calc => {
      return (
        <tr key={calc._id}>
          <td>{calc.index}</td>
          <td>{calc.prioridade}</td>
          <td>{calc.nome}</td>
          <td style={{ fontSize: 12 }}>
            {calc.valido_de &&
              <span>{moment(calc.valido_de).format("DD/MM/YYYY")}</span> ||
              <span>Sempre</span>}
            <Icon icon="arrow-right" style={{ margin: "0 5px" }} />
            {calc.valido_ate &&
              <span>{moment(calc.valido_ate).format("DD/MM/YYYY")}</span> ||
              <span>Sempre</span>}
          </td>
          <td className="nz-table-actions">
            <MDBBtn
              color="default"
              rounded
              size="sm"
              onClick={this.handleEdit.bind(this, calc)}
            >
              <img src="/images/edit.png" width={25} />
            </MDBBtn>
            <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
              <Tooltip content="Duplicar">
                <MDBBtn
                  color="default"
                  rounded
                  size="sm"
                  onClick={() => this.obs.duplicateName = `Cópia de ${calc.nome}`}
                >
                  <img src="/images/duplicate.svg" width={25} />
                </MDBBtn>
              </Tooltip>
              <div>
                <H5>Duplicar cálculo: {calc.nome}</H5>
                <FormGroup
                  label="Nome"
                  labelFor="nome"
                >
                  <InputGroup
                    id="nome"
                    value={this.obs.duplicateName}
                    onChange={(e: any) => this.obs.duplicateName = e.target.value}
                  />
                </FormGroup>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 15,
                  }}
                >
                  <Button
                    className={Classes.POPOVER_DISMISS}
                    style={{ marginRight: 10 }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    intent="primary"
                    className={Classes.POPOVER_DISMISS}
                    onClick={this.handleDuplicate.bind(this, calc)}
                  >
                    Duplicar
                  </Button>
                </div>
              </div>
            </Popover>

            <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
              <MDBBtn color="default" rounded size="sm">
                <img src="/images/bin.png" width={25} />
              </MDBBtn>
              <div>
                <H5>Confirmar exclusão?</H5>
                <p>Confirmar exclusão do cálculo {calc.nome}?</p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 15,
                  }}
                >
                  <Button
                    className={Classes.POPOVER_DISMISS}
                    style={{ marginRight: 10 }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    intent="danger"
                    className={Classes.POPOVER_DISMISS}
                    onClick={this.handleDelete.bind(this, calc)}
                  >
                    Excluir
                  </Button>
                </div>
              </div>
            </Popover>
          </td>
        </tr>
      );
    })

    const optionsClass = {
      searchField: this.createCustomSearchFieldSol,
    };

    const selectRowCalcs = {
      mode: "checkbox",
      clickToSelect: true,
      columnWidth: "40px",
      onSelect: this.handleCheckCalcs,
      onSelectAll: this.handleCheckCalcsAll,
      selected: this.state.listCalcs,
    };

    let calcs = CalcStore.obs.calcs_class?.map(obj => {

      return ({
        id: (obj.id || obj._id),
        nome: obj.nome,
      })

    });

    const selectRowClass = {
      mode: "checkbox",
      clickToSelect: true,
      columnWidth: "40px",
      onSelect: this.handleCheckClass,
      onSelectAll: this.handleCheckClassAll,
      selected: this.state.listIdsClass,
    };

    let classificacoes = CalcStore.obs.itens_classificacao?.map(obj => {

      return ({
        id: (obj.id || obj._id),
        nome: obj.nome,
      })

    });

    return (<>
      <div style={{ marginBottom: 100 }}>
        <MDBRow>
          <MDBCol md="12">
            <MDBBtn className="btnDefault noFloat" onClick={this.handleCreate}>
              Criar Cálculo
            </MDBBtn>
            <MDBBtn
              className="btnDefault noFloat"
              onClick={() => this.handleCreateClass()}
              style={{ marginLeft: 15 }}
            >
              Criar Classificação
            </MDBBtn>
          </MDBCol>
          <MDBCol md="3" className="inputFilterCalcs">
            <InputGroup
              round
              leftIcon="search"
              placeholder="Filtrar (Nome)"
              style={{ borderRadius: "10px" }}
              value={CalcStore.obs.filterText}
              onChange={(e: any) => this.handleFilter(e.target.value)}
              disabled={CalcStore.obs.tipo == "classificacao"}
            />
          </MDBCol>

          <MDBCol md="2">
            <FormGroup
              label={"Filtro cálculos"}
              labelFor="pendente"
              className="selectVigencia"
            >
              <HTMLSelect
                value={this.obs.filter_vigencia}
                onChange={(e: any) => this.handleChangeVigencia(e.target.value)}
                disabled={CalcStore.obs.tipo == "classificacao"}
              >
                <option value="vigentes">Vigentes</option>
                <option value="vencidas">Vencidos</option>
                <option value="futuras">Futuras</option>
              </HTMLSelect>
            </FormGroup>

          </MDBCol>

          <MDBCol md="12">
            <Tabs
              id="tabs"
              className={"tabsCalculos calcs"}
              onChange={(tableId) => this.handleChangeTab(tableId)}
              selectedTabId={CalcStore.obs.tipo}
            >
              <Tab id="entrada" title="Entrada" />
              <Tab id="saida" title="Saída" />
              <Tab id="outros" title="Outros" />
              <Tab id="contas" title="Exclusivos" />
              <Tab id="classificacao" title="Classificação" panel={<CalcsClassificacaoPage />} />
            </Tabs>
          </MDBCol>
        </MDBRow>

        {CalcStore.obs.tipo != "classificacao" &&

          <>

            <Tabs
              id="tabs"
              className={"tabsCalculos calcs"}
              onChange={(tableId) => CalcStore.obs.sub_tipo = String(tableId)}
              selectedTabId={CalcStore.obs.sub_tipo}
            >
              <Tab id="simples_nacional" title="Apenas Simples Nacional" />
              <Tab id="regime_e_sem_regime" title="Apenas Regime Normal" />
              <Tab id="simples_nacional_excesso" title="Apenas Regime Nacional Excesso" />
              <Tab id="regime_especial" title="Apenas Regime Especial" />
              <Tab id="outros" title="Outros" />
            </Tabs>

            <div className="TableDefault">
              <HTMLTable className="table table-hover dataTable" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th style={{ width: 100 }}>Código</th>
                    <th style={{ width: 100 }}>Prioridade</th>
                    <th>Nome</th>
                    <th style={{ width: 180 }} />
                    <th style={{ width: 180 }} />
                  </tr>
                </thead>
                <tbody>
                  {itemns}
                </tbody>
              </HTMLTable>
            </div>

          </>

        }
      </div>

      <Dialog
        isOpen={this.obs.modalCreateClassificacao}
        onClose={() => this.obs.modalCreateClassificacao = false}
        title="Criar nova classificação"
        className="AlertUser modalSefa"
      >
        <div className={Classes.DIALOG_BODY}>
          <div style={{ marginBottom: 10 }} className="AlertImportacoes">

            <MDBRow>
              <MDBCol>
                <FormGroup label="Código Receita" labelFor="codigo-receita" style={{ width: 300 }}>
                  <InputGroup
                    id="codigo-receita"
                    value={this.obs.codigo_receita}
                    onChange={(e: any) => this.obs.codigo_receita = e.target.value}
                  />
                </FormGroup>
              </MDBCol>
              <MDBCol>
                <FormGroup label="Código Ajuste" labelFor="codigo-ajuste" style={{ width: 300 }}>
                  <InputGroup
                    id="codigo-ajuste"
                    value={this.obs.codigo_ajuste}
                    onChange={(e: any) => this.obs.codigo_ajuste = e.target.value}
                  />
                </FormGroup>
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol size="6">
                <FormGroup label="Nome" labelFor="nome">
                  <InputGroup
                    id="nome"
                    value={this.obs.nome_classificacao}
                    onChange={(e: any) => this.obs.nome_classificacao = e.target.value}
                  />
                </FormGroup>
              </MDBCol>
              <MDBCol size="6">
                <FormGroup label="Código do ICMS recolhido ou a recolher" style={{ width: 300 }}>
                  <HTMLSelect
                    onChange={(e) => this.obs.cod_or = e.target.value}
                    value={this.obs.cod_or}
                  >
                    <option value="">Selecione</option>
                    <option value="090">090 - Outras obrigações do ICMS</option>
                    <option value="000">000 - ICMS a recolher</option>
                    <option value="005">005 - Antecipação tributária</option>
                  </HTMLSelect>
                </FormGroup>
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol size="4">
                <FormGroup label="DEI">
                  <Switch
                    label={this.obs.dei ? "Sim" : "Não"}
                    checked={this.obs.dei}
                    onChange={(e: any) => this.obs.dei = e.target.checked}
                  />
                </FormGroup>
              </MDBCol>
              <MDBCol size="4">
                <FormGroup label="DAE Avulso">
                  <Switch
                    label={this.obs.dae_avulso ? "Sim" : "Não"}
                    checked={this.obs.dae_avulso}
                    onChange={(e: any) => this.obs.dae_avulso = e.target.checked}
                  />
                </FormGroup>
              </MDBCol>
              <MDBCol size="4">
                <FormGroup label="Apuração Saída">
                  <Switch
                    label={this.obs.apuracao_saida ? "Sim" : "Não"}
                    checked={this.obs.apuracao_saida}
                    onChange={(e: any) => this.obs.apuracao_saida = e.target.checked}
                  />
                </FormGroup>
              </MDBCol>
            </MDBRow>

            <span><b style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => this.obs.open_select_calcs = true}>{"Selecione os Cálculos >> "}</b>
              <AppIcon name="help" className="pulse-notification-pgdas" color="blue" style={{ cursor: "pointer", marginLeft: 5 }} onClick={() => {
                this.obs.texto_ajuda = "Cálculos vinculados ao crédito pela entrada: se você estiver apurando a saída, o sistema buscará cada classificação da saída correspondente na entrada, apenas para os cálculos que você selecionar aqui."
                this.obs.open_ajuda = true
              }} />
            </span>

            <br />
            <br />

            {this.obs.apuracao_saida
              ? <span><b style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => this.obs.open_select_class = true}>{"Selecione as Classificações >> "}</b>
                <AppIcon name="help" className="pulse-notification-pgdas" color="blue" style={{ cursor: "pointer", marginLeft: 5 }} onClick={() => {
                  this.obs.texto_ajuda = "As classificações selecionadas serão agrupadas nesta nova que está sendo criada. Exemplo: ao criar a classificação X vinculando as classificações Y e Z, na apuração de saída aparecerá apenas a classificação (imposto) X."
                  this.obs.open_ajuda = true
                }} />
              </span>

              : <></>
            }

          </div>
        </div>

        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" onClick={() => this.obs.modalCreateClassificacao = false} />
            <Button text="Salvar" intent="primary" onClick={this.handleSaveClassificacao} />
          </div>
        </div>

      </Dialog>

      <Dialog
        isOpen={this.obs.open_select_calcs}
        onClose={() => this.obs.open_select_calcs = false}
        title="Cálculos"
      >
        <div className={Classes.DIALOG_BODY}>

          <div className="select-empresa-sefa select-calcs">
            <BootstrapTable data={calcs} selectRow={selectRowCalcs} options={optionsClass} search>
              <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
              <TableHeaderColumn dataField="nome" width="90%">Nome</TableHeaderColumn>
            </BootstrapTable>
          </div>

        </div>

        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" intent="primary" onClick={() => this.obs.open_select_calcs = false} />
          </div>
        </div>
      </Dialog>

      <Dialog
        isOpen={this.obs.open_select_class}
        onClose={() => this.obs.open_select_class = false}
        title="Classificações"
      >
        <div className={Classes.DIALOG_BODY}>
          <div className="select-empresa-sefa select-calcs">
            <BootstrapTable data={classificacoes} selectRow={selectRowClass} options={optionsClass} search>
              <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
              <TableHeaderColumn dataField="nome" width="90%">Nome</TableHeaderColumn>
            </BootstrapTable>
          </div>
        </div>

        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" intent="primary" onClick={() => this.obs.open_select_class = false} />
          </div>
        </div>
      </Dialog>

      <InfoModal open={this.obs.open_ajuda} onClose={() => this.obs.open_ajuda = false} texto_info={this.obs.texto_ajuda} />

    </>);
  }
}

export default CalcsPage;
